export class WithdrawRequestsRequestModel {
    RequestGuids: string[];
    WithdrawnReason :string;

    public constructor(requestGuids: string[], withdrawnReason:string){
        this.RequestGuids = requestGuids;
         this.WithdrawnReason = withdrawnReason;
    }
}